<div class="mobile-search">
    <ion-header class="ion-no-border">
        <ion-toolbar class="title-toolbar">
            <ion-title slot="start">{{ "productSearch.label" | translate }}</ion-title>
            <ion-buttons slot="end">
                <ion-button
                    fill="clear"
                    (click)="dismiss()"
                    [attr.aria-label]="'productSearch.close' | translate"
                >
                    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
        <ion-toolbar class="search-toolbar">
            <div class="searchbar-wrapper">
                <ion-searchbar
                    #searchbar
                    class="searchbar product-searchbar product-searchbar-mobile"
                    type="search"
                    inputmode="search"
                    autocomplete="off"
                    [autofocus]="true"
                    [debounce]="0"
                    [value]="query()"
                    [placeholder]="'keywordsearch' | translate"
                    [attr.aria-label]="'productSearch.label' | translate"
                    (ionInput)="onIonInput($event)"
                    (ionClear)="clearQuery()"
                    (keydown)="onKeydown($event)"
                ></ion-searchbar>
                <button
                    type="button"
                    class="searchbar-submit-button"
                    [attr.aria-label]="'productSearch.label' | translate"
                    (click)="onSearchButtonClick()"
                >
                    <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
                </button>
            </div>
        </ion-toolbar>
    </ion-header>

    <ion-content [fullscreen]="true" class="results-content">
        <div class="visually-hidden" aria-live="polite" aria-atomic="true">
            @switch (state().status) {
                @case ("loading") {
                    {{ "productSearch.status.loading" | translate }}
                }
                @case ("empty") {
                    {{ "productSearch.empty" | translate }}
                }
                @case ("error") {
                    {{ "productSearch.error" | translate }}
                }
                @case ("results") {
                    {{
                        "productSearch.status.results"
                            | translate: { count: state().results.totalCount }
                    }}
                }
            }
        </div>

        <ion-list class="results" lines="full" role="listbox" [attr.aria-label]="'productSearch.label' | translate">
            @if (state().status === "idle") {
                <ion-item lines="none" class="panel-state">
                    <ion-label>
                        <p>{{ "productSearch.emptyHint" | translate }}</p>
                    </ion-label>
                </ion-item>
            }

            @if (state().status === "loading") {
                <ion-item lines="none" class="panel-state loading-state">
                    <ion-spinner name="crescent"></ion-spinner>
                    <ion-label>{{ "productSearch.status.loading" | translate }}</ion-label>
                </ion-item>
            }

            @if (state().status === "error") {
                <ion-item lines="none" class="panel-state">
                    <ion-label>{{ "productSearch.error" | translate }}</ion-label>
                </ion-item>
            }

            @if (state().status === "empty") {
                <ion-item lines="none" class="panel-state">
                    <ion-label>
                        <h3>{{ "productSearch.empty" | translate }}</h3>
                        <p>{{ "productSearch.emptyHint" | translate }}</p>
                    </ion-label>
                </ion-item>
            }

            @if (state().status === "results") {
                @if (state().results.machines.length) {
                    <ion-list-header>
                        <ion-label>{{ "productSearch.groups.machines" | translate }}</ion-label>
                    </ion-list-header>
                    @for (item of state().results.machines; track item.id; let i = $index) {
                        <app-product-search-result-item
                            [result]="item"
                            [active]="isOptionActive(i)"
                            [compactBadges]="true"
                            (selected)="onResultSelected($event)"
                        ></app-product-search-result-item>
                    }
                }
                @if (state().results.variants.length) {
                    <ion-list-header>
                        <ion-label>{{ "productSearch.groups.variants" | translate }}</ion-label>
                    </ion-list-header>
                    @for (item of state().results.variants; track item.id; let i = $index) {
                        <app-product-search-result-item
                            [result]="item"
                            [active]="isOptionActive(state().results.machines.length + i)"
                            [compactBadges]="true"
                            (selected)="onResultSelected($event)"
                        ></app-product-search-result-item>
                    }
                }
            }

            @if (state().status === "results" || state().status === "empty") {
                <ion-item
                    button
                    detail="false"
                    lines="none"
                    class="show-all"
                    [class.active]="isShowAllActive()"
                    (click)="showAllResults()"
                >
                    <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
                    <ion-label>{{
                        "productSearch.showAllShort"
                            | translate: { count: state().results.totalCount }
                    }}</ion-label>
                </ion-item>
            }
        </ion-list>
    </ion-content>
</div>
